import React from "react";
import Navigator from "../navigator/Navigator";

class Jumbotron extends React.Component {


    render() {
       return( <div id="samplejumbo">

        </div>
       );

    }




}

export default Jumbotron;